<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Notatki'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-note-details-view *ngIf="!modify" [note]="note" (modifyClicked)="modify = true"></app-note-details-view>
    <app-note-add *ngIf="modify" [note]="note" (closeModification)="modify = false; loadNote()"></app-note-add>
  </mat-tab>
</mat-tab-group>
